// 🔧 vendor_generator.js
// ✅ Purpose: Generates Vendor Engine demo data
// ✅ Features:
// - Generates realistic event vendors
// - Industry-aware through DemoContext seed profile
// - Scales vendor count by demo size
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildVendorDefaults } from "./templates/vendor_defaults";

export const generateVendors = ({
  demoContext,
} = {}) => {
  console.log("🏪 Vendor Generator started.");

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  const demoSize =
    demoContext?.demoConfig?.size ||
    demoContext?.seedProfile?.demoSize ||
    "medium";

  const vendors = buildVendorDefaults({
    industryTemplate,
    demoSize,
  });

  console.log("✅ Vendor Generator completed.", {
    vendors: vendors.length,
    industryTemplate,
    demoSize,
  });

  return {
    vendors,
  };
};
